export const shotguns = Object.freeze({
  'Remington M870': {
    name: 'Remington M870',
    list: 'shotguns',
    calibre: '12 Gauge',
    qty: 1,
    length: 42,
    baseWeight: 7.89,
    rt: 30,
    rof: '2',
    mag: [{ type: 'Rnd', weight: 0.13, cap: 7, qty: 0 }],
    kd: 25,
    sab: 12,
    aim: {
      ac: [1, 3, 3, 4, 5, 6, 7, 8],
      mod: [-23, -12, -9, -7, -6, -4, -3, -2],
    },
    projectiles: [
      {
        type: 'Slug',
        pen: [7.7, 7.7, 7.6, 7.5, 7.5, 7.4, 7.3, 7.2, 6.9, 6.7, 5.7],
        dc: [10, 10, 10, 10, 10, 10, 10, 10, 10, 9, 9],
      },
      {
        type: 'Shot',
        pen: [5.4, 1.7, 1.7, 1.6, 1.6, 1.6, 1.4, 1.4, 1.2, 1.0, 0.6],
        dc: [8, 3, 3, 3, 3, 3, 2, 2, 2, 2, 1],
        salm: [-14, -9, -4, -1, 1, 2, 5, 7, 10, 12, 17],
        bphc: ['', '*11', '*10', '*9', '*7', '*5', '*2', '*1', 62, 35, 8],
        pr: ['.0', '.0', '.0', 0.1, 0.1, 0.1, 0.1, 0.2, 0.3, 0.4, 0.7],
      },
    ],
    ba: [67, 58, 48, 42, 38, 35, 29, 25, 19, 15, 5],
    tof: [0, 0, 0, 0, 0, 0, 1, 1, 1, 2, 4],
    offical: true,
  },
  'Ithaca LAPD': {
    name: 'Ithaca LAPD',
    list: 'shotguns',
    calibre: '12 Gauge',
    qty: 1,
    length: 38,
    baseWeight: 6.55,
    rt: 22,
    rof: '2',
    mag: [{ type: 'Rnd', weight: 0.13, cap: 5, qty: 0 }],
    kd: 15,
    sab: 9,
    aim: {
      ac: [1, 3, 3, 4, 5, 6, 7, 8],
      mod: [-22, -11, -9, -7, -5, -4, -3, -2],
    },
    projectiles: [
      {
        type: 'Slug',
        pen: [3.6, 3.6, 3.5, 3.5, 3.4, 3.4, 3.2, 3.1, 2.8, 2.6, 1.8],
        dc: [9, 9, 9, 9, 9, 9, 9, 9, 8, 8, 6],
      },
      {
        type: 'Shot',
        pen: [1.6, 1.6, 1.6, 1.5, 1.4, 1.4, 1.3, 1.2, 1.1, 0.9, 0.5],
        dc: [10, 4, 3, 3, 3, 3, 3, 3, 2, 2, 1],
        salm: [-13, -8, -3, 0, 2, 4, 7, 9, 11, 14, 19],
        bphc: ['', '*11', '*10', '*8', '*5', '*3', '*1', 74, 32, 17, 3],
        pr: ['.0', '.0', '.0', 0.1, 0.1, 0.1, 0.2, 0.3, 0.4, 0.6, 1.2],
      },
    ],
    ba: [61, 52, 42, 36, 32, 29, 23, 19, 13, 9, -1],
    tof: [0, 0, 0, 0, 0, 0, 1, 1, 1, 2, 4],
    offical: true,
  },
  'Sawed-Off Shotgun': {
    name: 'Sawed-Off Shotgun',
    list: 'shotguns',
    calibre: '12 Gauge',
    qty: 1,
    length: 20,
    baseWeight: 6.54,
    rt: 16,
    rof: '*',
    mag: [{ type: 'Rnd', weight: 0.13, cap: 2, qty: 0 }],
    kd: 14,
    sab: 9,
    aim: {
      ac: [1, 3, 3, 4, 5],
      mod: [-21, -13, -11, -11, -10],
    },
    projectiles: [
      {
        type: 'Slug',
        pen: [3.1, 3.0, 3.0, 2.9, 2.8, 2.8, 2.7, 2.6, 2.3, 2.1, 1.5],
        dc: [8, 8, 8, 8, 8, 8, 8, 8, 7, 7, 5],
      },
      {
        type: 'Shot',
        pen: [1.3, 1.3, 1.2, 1.2, 1.1, 1.1, 1.0, 0.9, 0.8, 0.7, 0.4],
        dc: [3, 3, 3, 3, 2, 2, 2, 2, 2, 1, 1],
        salm: [-9, -4, 1, 4, 6, 8, 11, 13, 16, 18, 23],
        bphc: ['*11', '*10', '*6', '*3', '*2', '*1', 44, 24, 10, 5, 0],
        pr: ['.0', '.0', 0.1, 0.1, 0.2, 0.2, 0.3, 0.4, 0.7, 0.9, 1.9],
      },
    ],
    ba: [61, 51, 41, 36, 31, 28, 23, 18, 13, 9, -1],
    tof: [0, 0, 0, 0, 0, 0, 1, 1, 1, 2, 4],
    offical: true,
  },
  'Saiga 12K': {
    name: 'Saiga 12K',
    list: 'shotguns',
    calibre: '12 Gauge',
    qty: 1,
    length: '26/36',
    baseWeight: 7.7,
    rt: 8,
    rof: '*',
    mag: [{ type: 'Mag', weight: 1.8, cap: 8, qty: 0 }],
    kd: 24,
    sab: 11,
    aim: {
      ac: [1, 3, 3, 4, 5, 6, 7, 8],
      mod: [-23, -13, -9, -7, -6, -4, -3, -2],
    },
    projectiles: [
      {
        type: 'Slug',
        pen: [7.5, 7.4, 7.4, 7.3, 7.3, 7.2, 7.1, 7.0, 6.7, 6.5, 5.6],
        dc: [10, 10, 10, 10, 10, 10, 10, 10, 9, 9, 9],
      },
      {
        type: 'Shot',
        pen: [5.4, 1.7, 1.6, 1.6, 1.6, 1.5, 1.4, 1.3, 1.1, 1.0, 0.6],
        dc: [8, 3, 3, 3, 3, 3, 2, 2, 2, 2, 1],
        salm: [-14, -9, -4, -1, 1, 2, 5, 7, 10, 12, 17],
        bphc: ['', '*11', '*10', '*9', '*7', '*5', '*2', '*1', 62, 35, 8],
        pr: ['.0', '.0', '.0', 0.1, 0.1, 0.1, 0.1, 0.2, 0.3, 0.4, 0.7],
      },
    ],
    ba: [67, 58, 48, 42, 38, 35, 29, 25, 19, 15, 5],
    tof: [0, 0, 0, 0, 0, 0, 1, 1, 1, 2, 4],
    offical: false,
  },
});
